import { Prelevement } from "../Shared/prelevement";

export class COFRAC {
    IsCofrac: boolean;
    Reason: string;

    static mapFromJSON(json: any): COFRAC {
        const p = new COFRAC();

        p.IsCofrac = json.isCofrac;
        p.Reason = json.reason;
        
        return p;
    }
}